import data from '@/e2e/state.json';

export const useMockedAuth = () => {
  const displayName = ref('');

  const getToken = async () => data.token;
  const signIn = async () => {
    return 'mocked signIn!';
  };
  const signOut = async () => {
    alert('mocked signOut!');
  };
  const sendPasswordResetEmail = async (email: string) => {
    alert('mocked sendPasswordResetEmail! email: ' + email);
  };

  return {
    signIn,
    signOut,
    displayName,
    getToken,
    sendPasswordResetEmail,
  };
};
